import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.167 12.345h10.657l-5.094 5.168.496.487 5.94-6-5.94-6-.496.487 5.094 5.168H6.167z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "arrow_right"}) } }